import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const EditFAQitemTwo = () => {
    const {id} = useParams();
    const [item, setItem] = useState([]);

    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq-item-two/${id}`)
            .then((res) => res.json())
            .then((info) => setItem(info));
    }, []);

    const handleAddItem = (event) => {
        event.preventDefault();
        const accodingTitleTwo = event.target.accodingTitleTwo.value;
        const accodingTextTwo = event.target.accodingTextTwo.value;
        

        const itemSection = {
            accodingTitleTwo,
            accodingTextTwo
            
        };

        const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/faq-item-two/${id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(itemSection),
        })
            .then((res) => res.json())
            .then((result) => {

                alert(' FAQ Item is Updated');
            });
    };


    return (
     <>   
    
        <div className='container vh-100 d-flex align-items-center justify-content-center'>
     <form class="contact-form" onSubmit={handleAddItem}>
         <div class="row">
             <div class="col-lg-12">
                 <div class="contact-field p-relative c-name ">
                     <input class="form-control form-control-lg shadow-lg p-3 mb-3  bg-white rounded" name="accodingTitleTwo" defaultValue={item.accodingTitleTwo} placeholder="FAQ Title" required />
                 </div>
             </div>

             <div class="col-lg-12">
                 <div class="contact-field p-relative c-name ">
                     <input class="form-control form-control-lg shadow-lg p-3 mb-3 bg-white rounded" name="accodingTextTwo" defaultValue={item.accodingTextTwo} placeholder="FAQ Text" required />
                 </div>
             </div>
          

             <div class="slider-btn text-center">
                 <button class="theme-btn btn-one " data-animation="fadeInRight"  data-delay=".8s"> FAQ Update </button>
             </div>
         </div>

     </form>

 </div></>
    );
};

export default EditFAQitemTwo;